import { render, staticRenderFns } from "./gridPrincipalItem.vue?vue&type=template&id=3bf09a3c&scoped=true&"
import script from "./gridPrincipalItem.vue?vue&type=script&lang=js&"
export * from "./gridPrincipalItem.vue?vue&type=script&lang=js&"
import style0 from "./gridPrincipalItem.vue?vue&type=style&index=0&id=3bf09a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf09a3c",
  null
  
)

export default component.exports